import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { ImgPosition } from '../type';
import { LandingPageEventsName } from '../../gzLandingPage/types';
import { GzCountDownWebComponent } from '../../../../ui/gzCountDown';
import {
  getMdrOnboardingTranslations,
  getMspTranslationsForCountdownByReason,
} from '../../gzLandingPage/view/gzLandingPageConfig/gz-landing-page-config';

@customElement('gz-trial-product-item')
export class GzTrialProductItemWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  productTitle = '';

  @property({ type: String, attribute: true, reflect: true })
  description = '';

  @property({ type: String, attribute: true, reflect: true })
  imageSrc = 'https://assets.thehansindia.com/h-upload/2021/07/31/1092805-tech.jpg?width=500&height=300';

  @property({ type: String, attribute: true, reflect: true })
  imageAlignment: ImgPosition = ImgPosition.TOP;

  @property({ type: Boolean, attribute: true, reflect: true })
  hasBackButton = false;

  @property({ type: Number, attribute: true, reflect: true })
  countDownTime = null;

  @property({ type: Number, attribute: true, reflect: true })
  mspStatus = null;

  @property({ type: Boolean, attribute: true, reflect: true })
  isMspMdrOnboarding = false;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="container d-flex">
        <div class="product-item-content d-flex">
          <div class="image-container ${this.countDownTime || this.isMspMdrOnboarding ? 'outer-image-container' : ''}">
            ${this.renderCountDown()}
            <img alt="" src="${this.imageSrc}" />
          </div>
          <div class="content">
            ${this.renderBackButton()}
            <div class="title fs-24">${this.productTitle}</div>
            <div class="description fs-14">${this.description}</div>
            <div class="slot-container">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  private renderCountDown() {
    if (this.countDownTime || this.isMspMdrOnboarding) {
      const component = new GzCountDownWebComponent();
      component.calendarStyle = true;
      component.classList.add('count-down');
      component.startTimer();
      if (this.countDownTime && this.mspStatus) {
        component.dateToTimestamp = this.countDownTime;
        const translations = getMspTranslationsForCountdownByReason(this.mspStatus);
        if (translations) {
          component.translations = translations;
        }
      }
      if (this.isMspMdrOnboarding) {
        component.inStandBy = this.isMspMdrOnboarding;
        component.standByTranslation = getMdrOnboardingTranslations().mdrOnboardingMessage;
        component.standByTooltip = getMdrOnboardingTranslations().mdrOnboardingTooltip;
      }
      return html`${component}`;
    }
  }

  private renderBackButton() {
    if (this.hasBackButton) {
      return html`
        <div class="back">
          <gz-icon name="ds-icon-arrow_left_collapse" size="24" color="secondary"></gz-icon>
          <gz-button
            type="quiet"
            class="back-btn"
            color="secondary"
            buttonHeight="small"
            id="back-button"
            @click="${this.handleBackButtonClicked}"
            >Back
          </gz-button>
        </div>
      `;
    }
    return ``;
  }

  private handleBackButtonClicked(event: Event) {
    const clickEvent = new CustomEvent(LandingPageEventsName.SHOW_CARDS, {
      detail: {
        target: event.target,
      },
      bubbles: true,
      composed: true,
    });

    this.dispatchEvent(clickEvent);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    gzTrialProductItem: GzTrialProductItemWebComponent;
  }
}
